// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1654":"e2eb967f0e1969b3","7340":"8d6070fcfc898c34","8575":"00565eb1b8984240","9005":"26fac1a6a74005fe","9640":"ed0fa357d3d4d1ac"}[chunkId] + ".css";
};